<template>
  <div >
    <div class="row">
    <ul class="collapsible tasks" ref="collapsible">
        <li v-for="[name, skill] in sortedSkills" :key="name">
            <div class="collapsible-header">
                {{name}}
            </div>
            <div class="collapsible-body">                
              <div class="row">
                <div class="input-field col s9">
                  <input :id="'key-'+name" :value="name" type="text" class="validate" @change="onChangeSkillKey(name, skill,$event)" />
                  <label :for="'key-'+name" class="active">Key</label>
                </div>
                <div class="input-field col s3">
                  <label>
                    <input type="checkbox" class="filled-in" v-model="skill.init" />
                    <span>Init</span>
                  </label>
                </div>
                <div class="input-field col s12">
                  <input :id="'name-'+name" v-model="skill.name" type="text" class="validate" />
                  <label :for="'name-'+name" class="active">Name</label>
                </div>
              </div>
              <div class="row">
                <div class="input-field col s3">
                  <input :id="'unit-'+name" v-model.number="skill.unit" type="text" class="validate" />
                  <label :for="'unit-'+name" class="active">Unit</label>
                </div>
                <div class="input-field col s9">
                  <select :id="'type-'+name" v-model="skill.type" class="browser-default">
                    <option v-for="type in skillTypes" :key="type.name" :value="type.name">
                      {{type.label}}
                    </option>
                  </select>
                </div>
              </div>
              <div class="row">
              
              <div class="input-field col s12">
                <input :id="'targetFormula-'+name" v-model="skill.targetFormula" type="text" class="validate" />
                <label :for="'targetFormula-'+name" class="active">Target Formula</label>
              </div>
              </div>
              <div class="row">
                <div class="input-field col s12">
                  <textarea :id="'description-'+name" v-model="skill.description" class="browser-default" rows="5" />
                  <label :for="'description-'+name" class="active">Description</label>
                </div>
              </div>
              <div class="row">
                  <div class="col s3"></div>
                  <div class="col s9">
                    <a class="right" @click="removeSkill(name)"><i class="material-icons red-text">delete</i></a>
                  </div>
              </div>
            </div>
        </li>
    </ul>
  </div>
  <div class="row">
    <div class="col s6 center-align"> 
      <a class="waves-effect waves-light btn blue " @click="addSkill()">Add
      </a>
    </div>
    <div class="col s6 center-align"> 
      <a class="waves-effect waves-light btn green " @click="save()">Save
      </a>
    </div>
  </div>
</div>
</template>

<script>
import M from 'materialize-css'
import api from '@/api'
export default {
  name: 'skills',
  props: {
    user: Object
  },
  components: {},
  data: function () {
    return {
      skillTypes: [],
      skills: []
    }
  },
  computed: {
    sortedSkills () {
      return Object.entries(this.skills).sort()
    }
  },
  created () {
    this.skillTypes = api.getProgramTaskTypes()
    this.skills = api.getSkills()
  },
  mounted () {
    M.Collapsible.init(this.$refs.collapsible, {})
  },
  methods: {
    addSkill: function () {
      const n = Object.keys(this.skills).length
      const newKey = 'new-' + n
      const nSkill = {}
      nSkill[newKey] = {
        type: undefined,
        name: 'New',
        description: '',
        unit: undefined,
        targetFormula: '1.5* user.athlete.weight * 0.85',
        init: false
      }
      this.skills = Object.assign(nSkill, this.skills) // to refresh the object
    },
    removeSkill: function (name) {
      delete this.skills[name]
      this.skills = {...this.skills}
    },
    save: function () {
      api.updateSkills(this.skills)
      M.toast({html: 'Skills saved'})
    },
    onChangeSkillKey: function (oldKey, skill, $event) {
      const newKey = $event.target.value
      this.skills[newKey] = skill
      delete this.skills[oldKey]
      this.skills = {...this.skills} // refresh the object
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/coach/SkillEdit.vue